import { Box, Button } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { useDocTransmittalContext } from "../DocTransmittal.context";

export default function ActionsBtns({ row }) {
  const { onCLickAddNewRev } = useDocTransmittalContext();

  return (
    <Box sx={{ textAlign: "right" }}>
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        color="primary"
        sx={{ m: 1 }}
        onClick={() => onCLickAddNewRev({ row })}
      >
        Add New Rev.
      </Button>
    </Box>
  );
}
